<div class="slider-container" [class.minimal]="variant() === 'minimal'">
  <div class="slider-row">
    <input
      type="range"
      class="slider-track"
      [min]="min()"
      [max]="max()"
      [step]="step()"
      [value]="currentValue()"
      [style.--slider-progress]="progressPercent()"
      [style.--slider-color]="resolvedColor()"
      (input)="onSliderDrag($event)"
      (change)="onSliderChange($event)"
    />
    @if (editable()) {
      <span class="param-label">{{ param() }} =</span>
      <input
        type="number"
        class="value-input"
        [class.invalid]="inputCtrl.invalid"
        [formControl]="inputCtrl"
        [min]="min()"
        [max]="max()"
        [step]="step()"
      />
    } @else {
      <span class="param-value-inline">
        <span class="param-label">{{ param() }} =</span>
        <span class="value-display">{{ currentValue() }}</span>
      </span>
    }
  </div>
  @if (editable() && inputCtrl.invalid && inputCtrl.touched) {
    <div class="error-message">
      @if (inputCtrl.errors?.['min']) {
        Value must be at least {{ min() }}
      } @else if (inputCtrl.errors?.['max']) {
        Value must be at most {{ max() }}
      } @else if (inputCtrl.errors?.['required']) {
        Value is required
      }
    </div>
  }
</div>
